import {TranslationObject} from '@colonist/i18n'
import {ImageURL, ModeSettingEnum} from '@colonist/types'
import {CardEnum, PlayerColor} from '@colonist/game-states'
// eslint-disable-next-line no-restricted-imports
import {UIImagePathController} from '../../../../../../../code/client/shared/scripts/UIEnums.ts'
import CardDevelopmentCardBack from '@static/images/card_devcardback.svg'
import IconKnightUpgrade from '@static/images/icon_knight_upgrade.svg'
import IconSquareActiveTrade from '@static/images/icon_square_active_trade.svg'
import IconSquareActivePolitics from '@static/images/icon_square_active_politics.svg'
import IconSquareActiveScience from '@static/images/icon_square_active_science.svg'

enum CostInformationPieceTypes {
    City,
    Settlement,
    Road,
    DevelopmentCard,
    Ship,
    CityWall,
    PurchaseKnight,
    ActivateKnight,
    UpgradeKnight,
    Science,
    Trade,
    Politics
}

export interface CostInformation {
    piece: CostInformationPieceTypes
    cost: CardEnum[]
    title: TranslationObject
}

const baseGameCostsInformation: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.Road,
        cost: [CardEnum.Lumber, CardEnum.Brick],
        title: {key: 'strings:game.PieceTypes.Road'},
    },
    {
        piece: CostInformationPieceTypes.Settlement,
        cost: [CardEnum.Lumber, CardEnum.Brick, CardEnum.Wool, CardEnum.Grain],
        title: {key: 'strings:game.PieceTypes.Settlement'},
    },
    {
        piece: CostInformationPieceTypes.City,
        cost: [CardEnum.Grain, CardEnum.Grain, CardEnum.Ore, CardEnum.Ore, CardEnum.Ore],
        title: {key: 'strings:game.PieceTypes.City'},
    },
]

const developmentCostInformation: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.DevelopmentCard,
        cost: [CardEnum.Wool, CardEnum.Grain, CardEnum.Ore],
        title: {key: 'strings:game.PieceTypes.DevelopmentCard', options: {context: 'Abbreviated'}},
    },
]

const seafarersCosts: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.Ship,
        cost: [CardEnum.Lumber, CardEnum.Wool],
        title: {key: 'strings:game.PieceTypes.Ship'},
    },
]

const citiesAndKnightsCosts: CostInformation[] = [
    {
        piece: CostInformationPieceTypes.CityWall,
        cost: [CardEnum.Brick, CardEnum.Brick],
        title: {key: 'strings:game.PieceTypes.CityWall'},
    },
    {
        piece: CostInformationPieceTypes.PurchaseKnight,
        cost: [CardEnum.Wool, CardEnum.Ore],
        title: {key: 'strings:game.tooltips.purchaseKnight'},
    },
    {
        piece: CostInformationPieceTypes.ActivateKnight,
        cost: [CardEnum.Grain],
        title: {key: 'strings:game.gameState.actions.activateKnightSelf'},
    },
    {
        piece: CostInformationPieceTypes.UpgradeKnight,
        cost: [CardEnum.Wool, CardEnum.Ore],
        title: {key: 'strings:game.gameState.actions.upgradeKnightSelf'},
    },
    {
        piece: CostInformationPieceTypes.Trade,
        cost: [CardEnum.Cloth],
        title: {key: 'strings:game.cards.progress.title.Trade'},
    },
    {
        piece: CostInformationPieceTypes.Politics,
        cost: [CardEnum.Coin],
        title: {key: 'strings:game.cards.progress.title.Politics'},
    },
    {
        piece: CostInformationPieceTypes.Science,
        cost: [CardEnum.Paper],
        title: {key: 'strings:game.cards.progress.title.Science'},
    },
]

export function getCostInformation(gameMode: ModeSettingEnum): CostInformation[] {
    switch(gameMode) {
        case ModeSettingEnum.Seafarers4P:
        case ModeSettingEnum.Seafarers56P:
            return [...baseGameCostsInformation, ...developmentCostInformation, ...seafarersCosts]
        case ModeSettingEnum.CitiesAndKnights4P:
        case ModeSettingEnum.CitiesAndKnights56P:
            return [...baseGameCostsInformation, ...citiesAndKnightsCosts]
        case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
        case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            return [...baseGameCostsInformation, ...seafarersCosts, ...citiesAndKnightsCosts]
        default:
            return [...baseGameCostsInformation, ...developmentCostInformation]
    }
}

export function getPieceIconPath(piece: CostInformationPieceTypes, color: PlayerColor): ImageURL {
    const isPlayerSpectator = color === 0
    color = isPlayerSpectator ? PlayerColor.Blue : color
    switch(piece) {
        case CostInformationPieceTypes.Road:
            return UIImagePathController.roadsByColor[color]
        case CostInformationPieceTypes.Settlement:
            return UIImagePathController.settlementsByColor[color]
        case CostInformationPieceTypes.City:
            return UIImagePathController.citiesByColor[color]
        case CostInformationPieceTypes.DevelopmentCard:
            return CardDevelopmentCardBack
        case CostInformationPieceTypes.Ship:
            return UIImagePathController.shipsByColor[color]
        case CostInformationPieceTypes.CityWall:
            return UIImagePathController.cityWallsByColor[color]
        case CostInformationPieceTypes.PurchaseKnight:
            return UIImagePathController.knightsInactiveByColor[color]
        case CostInformationPieceTypes.ActivateKnight:
            return UIImagePathController.knightsActiveByColor[color]
        case CostInformationPieceTypes.UpgradeKnight:
            return IconKnightUpgrade
        case CostInformationPieceTypes.Trade:
            return IconSquareActiveTrade
        case CostInformationPieceTypes.Politics:
            return IconSquareActivePolitics
        case CostInformationPieceTypes.Science:
            return IconSquareActiveScience
    }
}
